
import React, { useState, useEffect } from "react";
import Layout from "@/components/layout/Layout";
import FinanceiroTabs from "@/components/financeiro/FinanceiroTabs";
import PagamentosTabContent from "@/components/financeiro/tabs/PagamentosTabContent";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { Toaster } from "sonner";

const FinanceiroPagamentosPage = () => {
  const [tabAtiva, setTabAtiva] = useState("pagamentos");
  
  const handleTabChange = (value: string) => {
    setTabAtiva(value);
    
    // Disparar evento personalizado para comunicação entre componentes
    const event = new CustomEvent('change-tab', {
      detail: { tab: value }
    });
    window.dispatchEvent(event);
    
    // Atualizar URL para refletir a aba selecionada
    const url = new URL(window.location.href);
    url.searchParams.set('tab', value);
    window.history.pushState({}, '', url);
  };
  
  // Get the URL parameters to see if a specific tab should be activated
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get('tab');
    if (tab) {
      setTabAtiva(tab);
    }
  }, []);
  
  return (
    <Layout>
      <div className="container mx-auto p-4 md:p-6 max-w-7xl">
        <div className="flex flex-col mb-6">
          <div className="mb-4">
            <h1 className="text-2xl font-normal text-gray-700 mb-1">Financeiro</h1>
            <p className="text-sm text-gray-500 mt-1 opacity-75">
              Gerenciamento de pagamentos
            </p>
          </div>
          <div className="w-full rounded-lg shadow-sm overflow-hidden">
            <FinanceiroTabs 
              tabAtiva={tabAtiva} 
              onChangeTab={handleTabChange} 
              variant="buttons"
              className="overflow-x-auto pb-2 md:pb-0" 
            />
          </div>
        </div>
        
        <Tabs 
          defaultValue="pagamentos" 
          className="w-full" 
          value={tabAtiva} 
          onValueChange={handleTabChange}
        >
          <TabsContent value="pagamentos">
            <PagamentosTabContent />
          </TabsContent>
        </Tabs>
        
        <Toaster position="top-right" />
      </div>
    </Layout>
  );
};

export default FinanceiroPagamentosPage;
